const general = {
  meetingScore: "Represents the combined sentiment and engagement.",
  sentiment:
    "Participant(s) attitude towards the meeting, measured by audio and visual cues.",
  engagement:
    "Participant(s) attentiveness of the meeting, measured by audio and visual cues.",
  talkTime:
    "Percentage a participant spoke out of the total speaking minutes in the meeting",
  lateStart:
    "Percentage of your meetings that you were late to or started late",
  cameraOff:
    "Percentage of time your camera was off and the average across all participants",
  micOff: "Percentage of time a participant's microphone was switched off",
};

const calendar = {
  flexibleMeeting:
    "With flexible meetings, Read will reschedule for the best time as your calendar changes. Read takes into account Focus Time, times with positive Engagement, and historical meeting overages.",
  inviteRead:
    "This option invites or disinvites your own Read Assistant to the meeting. Other Read users in the meetings may invite their own Read Assistants as well.",
  shareDisabledInviteRead:
    "Add Read to manage sharing preferences for this meeting",
  accessDisabledInviteRead:
    "Add Read to manage access preferences for this meeting",
  cannotInviteRead: {
    noVc: "Read cannot join meetings that do not have video conferencing",
    eventIsPrivate:
      "You cannot add Read because the report owner has restricted access",
  },
  predictedRole:
    "Your predicted role for the meeting determines your report sharing and distribution capabilities.",
};

const table = {
  ...general,
  participantScore:
    "Represents participant's combined sentiment and engagement. 70 to 80 is average",
  joinTime:
    "Minutes elapsed from meeting start by either you or the average of all participants",
  timeInMeeting:
    "Minutes in meeting by either you or the average of all participants",
  attendance:
    "Number of invited guests divided by number of attendees seen on the call",
  charisma:
    "How participants respond to you when you speak. 70 to 80 is indifferent, 81+ is positive",
  bias: "How you respond when others speak. 70 to 80 is indifferent, 81+ is positive",
};

const meetingReport = {
  ...general,
  participantScore:
    "Represents your combined sentiment and engagement. 70 to 80 is average", // different from table data, specific to YOU
  sentiment: `${general.sentiment} 70 to 80 is average`,
  engagement: `${general.engagement} 70 to 80 is average`,
  charisma: table.charisma,
  bias: table.bias,
  joinTime:
    "Minutes elapsed from meeting start by either you or the average of all participants",
  timeInMeeting:
    "Minutes in meeting by either you or the average of all participants",
  attendance:
    "Number of invited guests divided by number of attendees seen on the call",
  talkTime:
    "Percentage you spoke out of the total speaking minutes in the meeting vs the average of all participants",
  recommendations:
    "Suggestions that a user could take based on the overall meeting metrics (e.g. Engagement, Sentiment)",
  lockedMetric: {
    recordingDisabled:
      "This metric is not available because recording was not enabled in this meeting.",
  },
};

const meetingPolicy = {
  readAverage:
    "Metric average of meetings measured by Read in the US and Canada.",
};

const recommendations = {
  sampleActionDisabled: "Cannot take action on a sample recommendation",
};

const upsell = {
  upgradeToPro: "Upgrade to unlock Pro features!",
};

const coaching = {
  bias: "Your visual sentiment towards the speaker, measured out of 100",
  charisma: "Others' visual sentiment when you speak, measured out of 100",
  fillerWords:
    "Filler words are recognized as unnecessary words such as “um” and “like”",
  interruptions:
    "Number of times you interrupted another participant, or where cross-talk was detected",
  nonInclusiveTerms:
    "Your usage of words that are potentially offensive or harmful",
  questionsAsked: "Questions you asked during the meeting",
  talkingPace:
    "Your average rate of speech, measured in words per minute (WPM)",
};

export const TOOLTIPS = {
  calendar,
  coaching,
  meetingReport,
  meetingPolicy,
  recommendations,
  upsell,
};

export const STANDINGS_DESCRIPTIONS: { [index: string]: string } = {
  meetingScore:
    "Individual Read Score based on sentiment, engagement, and other factors", // different from table data, specific to YOU
  participantSentiment:
    "Attitude towards the meeting, based on audio and facial cues",
  participantEngagement:
    "Attention during the meeting, based on audio and facial cues, and camera state",
  participantCharisma:
    "How positively or negatively others reacted when you spoke",
  participantBias: "How positively or negatively you reacted when others spoke",
  cameraOffPercent: "Percentage of the meeting where the camera was off",
  microphoneOffPercent:
    "Percentage of the meeting where the microphone was muted",
};
